import React, { Fragment } from 'react'
import { ButtonLink, Loader, Button } from 'stylist'
import { Route, Switch } from 'react-router-dom'
import RouteShow from './show'
import RouteEdit from './edit'
import Company from 'components/Company'
import CompanyProvider from 'components/Company/Provider'
import Header from 'components/Header'

const RouteCompany = ({
  match: { url, path, params },
  history: { goBack },
  location
}) => (
  <CompanyProvider variables={params}>
    <Company
      render={({ loading, company }) =>
        loading ? (
          <Loader size="lg" centered />
        ) : (
          <Fragment>
            <Button marginBottom onClick={goBack} size="sm">
              Back
            </Button>
            <Header>
              <div>
                <h3>{company.name}</h3>
              </div>
              <div>
                {!/\/edit\/?$/.test(location.pathname) && (
                  <ButtonLink to={`${url}/edit`}>Edit</ButtonLink>
                )}
              </div>
            </Header>
            <div>
              <Switch>
                <Route path={`${path}/edit`} component={RouteEdit} />
                <Route path={url} component={RouteShow} />
              </Switch>
            </div>
          </Fragment>
        )
      }
    />
  </CompanyProvider>
)

export default RouteCompany



// WEBPACK FOOTER //
// ./src/routes/admin/companies/company.js